import React from 'react';

/** Video illustration — dark 16:9 frame with corner brackets, play triangle, time-scrubber. */
const PlayFrame = () => (
  <div className="ill-frame" aria-hidden="true">
    <span className="ill-frame-corner tl"></span>
    <span className="ill-frame-corner tr"></span>
    <span className="ill-frame-corner bl"></span>
    <span className="ill-frame-corner br"></span>
    <span className="ill-play">
      <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor">
        <path d="M8 5v14l11-7z" />
      </svg>
    </span>
    <span className="ill-frame-timebar"></span>
  </div>
);

export default PlayFrame;
